import type { InputDomRef } from "@ui5/webcomponents-react";

/**
 * Lists longer than this are searched (`SmartSelect`) by the field components that also take short fixed lists; a few
 * fixed choices (yes / no, a status) stay a plain drop-down.
 */
export const searchableFrom = 7;

export const handled = (event: { preventDefault: () => void; stopPropagation: () => void }) => {
  event.preventDefault();
  event.stopPropagation();
};

/** The native input inside a UI5 input. */
export function nativeInputOf(input: InputDomRef | null): HTMLInputElement | null {
  const native = (input as { nativeInput?: HTMLInputElement | null } | null)?.nativeInput;
  return native ?? input?.shadowRoot?.querySelector("input") ?? null;
}
